import React, { useEffect } from 'react';
import styled from 'styled-components';

import { LoadingCard } from 'app/components/Table/loading/LoadingCard';

import { injectDragToScroll } from 'app/helpers/utils';
import { useBoolean } from 'app/hooks';

import { ActionBin } from '../racks/core/enum';
import BinDetailCard from './components/BinDetailCard';
import { Bin } from './core/type';

const Main = styled.div`
  width: 100%;
  padding-top: 55px;
`;
export const GridView = styled.div<{ $totalColumns: number; $totalRows: number }>`
  display: grid;
  grid-template-columns: repeat(${(props) => props.$totalColumns}, 1fr);
  gap: 12px;
  padding: 28px;
  overflow-x: auto;
  user-select: none;
`;
const BinNoItem = styled.div`
  padding: 8px 6px 6px;
  height: 126px;
  border: 1px solid transparent;
  border-radius: 8px;
`;

interface Props {
  bins: Bin[];
  onClickModal: (key: ActionBin, originBin: Bin) => void;
  inSession?: boolean;
}
const ViewListBin: React.FC<Props> = ({ bins, onClickModal, inSession }) => {
  injectDragToScroll('bin-layout');
  const isLoading = useBoolean(true);

  useEffect(() => {
    setTimeout(() => {
      isLoading.setValue(false);
    }, 500);
  }, []);

  const totalColumns = Math.max(...bins.map((bin) => bin.col || 0));
  const totalRows = Math.max(...bins.map((bin) => bin.row || 0));

  const newBins: any = [];
  for (let row = 1; row <= totalRows; row++) {
    for (let col = 1; col <= totalColumns; col++) {
      const binExists = bins.some((bin) => bin.row === row && bin.col === col);
      if (!binExists) {
        newBins.push({ row, col, id: undefined });
      } else {
        newBins.push(bins.find((bin) => bin.row === row && bin.col === col));
      }
    }
  }
  return (
    <Main className="d-flex flex-column">
      <GridView id="bin-layout" $totalColumns={totalColumns} $totalRows={totalRows}>
        {newBins.map((bin) => {
          return !bin.id ? (
            <div
              key={`${bin.row}-${bin.col}`}
              style={{
                position: 'relative',
                background: 'transparent',
                borderRadius: '8px',
                cursor: 'pointer',
                border: 'none',
              }}
            ></div>
          ) : (
            <BinDetailCard
              bin={bin}
              key={bin.id}
              onClickModal={onClickModal}
              inSession={inSession}
            />
          );
        })}

        {isLoading.value && <LoadingCard />}
      </GridView>
    </Main>
  );
};
export default ViewListBin;
